import React from "react";
import classNames from "classnames";
import "assets/scss/helpers/customInput.scss";

export default function CustomInput(props) {
  const {
    inputRef = null,
    startIcon,
    disabled = false,
    endIcon,
    style,
    formGroup = true,
    inputProps = false,
    onChange,
    id,
    inputClass = false,
    errorStyle,
    readOnly = false,
  } = props;
  const formField = classNames({
    "form-feild": true,
    outlineFormField: inputProps.error && true,
    [inputClass]: inputClass && true,
    errorField: inputProps.error && true,
  });

  return (
    <React.Fragment>
      <div
        className={classNames({
          formGroup: formGroup ? true : false,
          style: style ? true : false,
        })}
        style={style}
      >
        {startIcon && startIcon}
        <input
          ref={inputRef}
          onChange={onChange}
          className={formField}
          id={id}
          {...inputProps}
          disabled={disabled}
          readOnly={readOnly}
        />
        {endIcon && endIcon}
      </div>
      {inputProps.error && (
        <div className="errorMessage" style={errorStyle}>
          {inputProps.error}
        </div>
      )}
    </React.Fragment>
  );
}
